const getSiteUrl = () => import.meta.env.VITE_SITE_URL || window.location.origin;

const analyticsReady = () =>
  typeof window !== 'undefined' &&
  typeof window.gtag === 'function' &&
  window.__dayforitAnalyticsLoaded;

export const trackEvent = (name, params = {}) => {
  if (!analyticsReady()) return;

  window.gtag('event', name, params);
};

export const trackPageView = ({ title, path }) => {
  if (!analyticsReady()) return;

  const url = new URL(path, getSiteUrl()).toString();
  window.gtag('event', 'page_view', {
    page_title: title,
    page_path: path,
    page_location: url,
  });
};

export const trackLocationPermissionResult = ({ source, entryPoint }) => {
  trackEvent('location_permission_result', {
    source,
    entry_point: entryPoint,
  });
};

export const trackDirectionsClick = ({ destinationType, destinationName }) => {
  trackEvent('get_directions', {
    destination_type: destinationType,
    destination_name: destinationName,
  });
};
